import { MaskLines, Reveal } from "../motion/Reveal.jsx";

export default function SectionHeading({ eyebrow, lines, copy, align = "left", dark = false, className = "" }) {
  const alignCls = align === "center" ? "items-center text-center mx-auto" : "items-start text-left";
  return (
    <div className={`flex max-w-3xl flex-col gap-5 ${alignCls} ${className}`}>
      {eyebrow && (
        <Reveal>
          <p className="eyebrow flex items-center gap-3">
            <span className="inline-block h-[2px] w-8 bg-brand" />
            {eyebrow}
          </p>
        </Reveal>
      )}
      <MaskLines
        lines={lines}
        className={`font-display text-4xl leading-[1.05] sm:text-5xl lg:text-6xl ${dark ? "text-white" : "text-navy"}`}
      />
      {copy && (
        <Reveal delay={0.15}>
          <p className={`max-w-xl text-base leading-relaxed md:text-lg ${dark ? "text-white/70" : "text-mute"}`}>
            {copy}
          </p>
        </Reveal>
      )}
    </div>
  );
}
